export const renderMarksEnums = {
  HIGHLIGHT_GRAMMAR_ERROR: 'highlightGrammarError',
  HIGHLIGHT_ACTION_VERB_ERROR: 'highlightActionVerbError',
  HIGHLIGHT_PRONOUN_ERROR: 'highlightPronounError',
  HIGHLIGHT_SELECTED_ERROR: 'highlightSelectedError',
  HIGHLIGHT_DEFAULT_ERROR: 'highlightDefaultError',
  FAKE_SELECTION: 'fakeSelection',
  HIGHLIGHT_ADDRESS_ERROR: 'highlightAddress',
};

export const renderMarksColors = {
  [renderMarksEnums.HIGHLIGHT_GRAMMAR_ERROR]: '#FFC0CB',
  [renderMarksEnums.HIGHLIGHT_ACTION_VERB_ERROR]: '#FFDAB9',
  [renderMarksEnums.HIGHLIGHT_PRONOUN_ERROR]: '#AFEEEE',
  [renderMarksEnums.HIGHLIGHT_SELECTED_ERROR]: '#FFFF00',
  [renderMarksEnums.HIGHLIGHT_DEFAULT_ERROR]: '#FFDAB9',
  [renderMarksEnums.HIGHLIGHT_ADDRESS_ERROR]: '#FFA07A',
};

export const markTypesToCheck = [
  renderMarksEnums.FAKE_SELECTION,
  renderMarksEnums.HIGHLIGHT_GRAMMAR_ERROR,
  renderMarksEnums.HIGHLIGHT_ACTION_VERB_ERROR,
  renderMarksEnums.HIGHLIGHT_PRONOUN_ERROR,
  renderMarksEnums.HIGHLIGHT_SELECTED_ERROR,
  renderMarksEnums.HIGHLIGHT_DEFAULT_ERROR,
  renderMarksEnums.HIGHLIGHT_ADDRESS_ERROR,
];
